<template>
  <v-card style="font-size: 28px;"  flat class="nosepara_topbot">
    <v-icon :size="calculaSize(counter_limit)" :color="getColor[w_type]" v-for="item in (counter_limit-counter) " :key="item+'a'">developer_board</v-icon>
    <v-icon :size="calculaSize(counter_limit)" :color="getColorLow[w_type]" v-for="item in (counter_limit-(counter_limit-counter)) " :key="item+'b'">developer_board</v-icon>
    <v-icon :size="40" color="#B1B1B1" v-if="counter_limit === 0">developer_board</v-icon>
    <v-chip label color="white" :text-color="getColor[w_type]">
      <span style="font-size: 20px !important; font-weight: 500; line-height: 1 !important; letter-spacing: 0.02em !important; font-family: 'Roboto', sans-serif !important;">
        {{counter_limit-counter}}/{{counter_limit}}
      </span>
    </v-chip>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["counter", "counter_limit", "w_type"],
  computed: {
    ...mapGetters(["getColor", "getColorLow"])
  },
  methods: {
    calculaSize(limit) {
      switch (true) {
        case limit >= 30:
          return 15;
        case limit >= 20:
          return 20;
        case limit >= 10:
          return 40;
        default:
          return 40;
      }
    }
  }
};
</script>
<style scoped>
.nosepara_topbot{
    /*padding: 6px 20px !important;*/
    position: static !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
</style>